import { ConnectedPosition } from '@angular/cdk/overlay';

export const dropDownMenuPosition: ConnectedPosition = {
    originX: 'end',
    originY: 'bottom',
    overlayX: 'end',
    overlayY: 'top',
    offsetY: 15
};
